<template>
  <transition name="fade">
    <div v-show="isOverlay" class="overlay"></div>
  </transition>
  <transition name="fade">
    <div v-show="isLoading" class="spinner-wrap">
      <div class="loading-box">
        <!--        <i><img src="@/assets/images/common/ARTICLE21_B.I.svg" alt=""/></i>-->
        <span class="main-spinner"></span>
        <p class="loading-message">{{ loadingMessage }}</p>
      </div>
    </div>
  </transition>
<!--  <div v-show="isBlurred" class="blurred-overlay"></div>-->
</template>

<script setup>
import {storeToRefs} from 'pinia'
import {useUiStore} from "@/store/useUiStore";
import {onMounted, onUnmounted, ref} from "vue";

const uiStore = useUiStore();
const {isOverlay, isLoading, loadingMessage } = storeToRefs(uiStore)

/* // 캡처할때 다시 포커스됨. 포커스말고 다른방법 있나..
const isBlurred = ref(true);
setTimeout(
    () => {
      isBlurred.value = false;
    }, 0
)
const handleBlur = () => {
  isBlurred.value = true;
};

const handleFocus = () => {
  isBlurred.value = false;
};

onMounted(() => {
  window.addEventListener("blur", handleBlur);
  window.addEventListener("focus", handleFocus);
});

onUnmounted(() => {
  window.removeEventListener("blur", handleBlur);
  window.removeEventListener("focus", handleFocus);
});
*/

</script>

<style scoped>
/* 임시 스피너 */
.main-spinner {
  width: 40px;
  height: 40px;
  border: 6px solid #F7BE17;
  border-top: 6px solid #ffffff00;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.loading-message {
  margin-top: 1rem;
  font-weight: 500;
  text-align: center;
  color: #f7be17;
}
/*
.blurred-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.6) 10px,
      transparent 10px,
      transparent 20px
  );
  z-index: 9999;
  pointer-events: none;
}

*/

.blurred-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(20px) brightness(0.3);
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  pointer-events: none;
}


</style>